module.exports = __webpack_public_path__ + "img/Operations_B.0bc74d2b.svg";